import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./userForm.data.form";
import PATHS from "../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  InputText,
  InputSelect,
  InputCheck,
  InputFile,
  BreadCrumb,
  InputTextarea,
} from "@de-prado-dev/react-component-library";
import { PERSON_TYPES } from "../../../constants";
import { ConfirmFile, ListError } from "./userForm.styled";
// import { useDropzone } from "react-dropzone";

const UserForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    handleSubmit,
    onBack,
    edit,
    onAddField,
    onRemoveField,
    fields,
    inputField,
    setInputField,
  } = props;
  // const breads = [
  //   { label: t("home"), path: PATHS.HOME },
  //   { label: t("forms.course.title"), path: PATHS.LIST_COURSE },
  //   { label: t("forms.course.titleNew") },
  // ];

  return (
    <>
      <div className="row justify-content-center mt-4 mt-md-5">
        <div className="col-12 col-md-9 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {edit ? t("forms.user.form.titleEdit") : t("forms.user.form.titleNew")}
          </h3>
        </div>
      </div>
      {/* <BreadCrumb items={breads} /> */}

      <div className="row justify-content-center  ">
        <div className="col-12 col-md-8 col-lg-6">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="name"
                  className="form-control"
                  labelField={t("forms.user.form.labels.name")}
                  name="name"
                  placeholder=""
                  component={InputText}
                  fieldType="text"
                  mandatory
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Field
                  id="email"
                  className="form-control"
                  labelField={t("forms.user.form.labels.email")}
                  name="email"
                  placeholder=""
                  component={InputText}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 mt-2">
                <Field
                  id="password"
                  className="form-control"
                  labelField={t("forms.user.form.labels.password")}
                  name="password"
                  component={InputText}
                  fieldType="password"
                  showHidePassword
                  placeholder=""
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Field
                  id="passwordConfirm"
                  className="form-control"
                  labelField={t("forms.user.form.labels.passwordConfirm")}
                  name="passwordConfirm"
                  component={InputText}
                  fieldType="password"
                  showHidePassword
                  placeholder=""
                />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onBack()}
                  className="btn btn-lg btn-secondary me-2"
                >
                  {t("forms.form.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-primary">
                  {t("forms.form.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

UserForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const UserFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "UserForm",
})(UserForm);

export default UserFormF;
